import { render, staticRenderFns } from "./Page503.vue?vue&type=template&id=796d9e6c&scoped=true"
import script from "./Page503.vue?vue&type=script&lang=ts"
export * from "./Page503.vue?vue&type=script&lang=ts"
import style0 from "./Page503.vue?vue&type=style&index=0&id=796d9e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d9e6c",
  null
  
)

export default component.exports